import React, { FunctionComponent } from 'react';
import { Grid, Placeholder } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  container: {
    backgroundColor: '#fff',
    padding: '.625rem 1.25rem !important',
    borderRadius: '.25rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    margin: '.625em -1em !important',
  },
  statsRow: {
    padding: '0 !important',
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
};

const MerchantDetailsPlaceholder: FunctionComponent<Props> = ({ classes }) => (
  <Grid container className={classes.container}>
    <Grid.Row>
      <Grid.Column width={6} textAlign="left">
        <Placeholder>
          <Placeholder.Header image>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Header>
        </Placeholder>
      </Grid.Column>
      <Grid.Column width={10} textAlign="right">
        <Grid>
          <Grid.Row className={classes.statsRow}>
            <Grid.Column width={4}>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Image />
              </Placeholder>
            </Grid.Column>
            <Grid.Column width={4}>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Image />
              </Placeholder>
            </Grid.Column>
            <Grid.Column width={4}>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Image />
              </Placeholder>
            </Grid.Column>
            <Grid.Column width={4}>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Image />
              </Placeholder>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default withStyles(styles)(MerchantDetailsPlaceholder);
